import { FieldTypes, FileUrlFields, textNumberField } from 'drapcode-constant';
import { getCollectionFieldTraitOptions } from '../pluginComponentApi';
const { date, text } = FieldTypes;
export const getDataListTraits = async (componentType, collection, collections) => {
  const trait = {
    type: 'data-group-field',
    label: false,
    changeProp: 1,
  };
  if (componentType === 'bs-image') {
    trait.options = await fieldTraitImageSrcOptions(collection, collections);
    console.log('🚀 ~ file: traitsApi.js:14 ~ getDataListTraits ~ collection:', collection);
    trait.title = `Get Image from Collection - ${collection.collectionTitle}`;
    trait.name = 'data-img-src';
  } else if (['input', 'select', 'textarea', 'checkbox', 'file-input'].includes(componentType)) {
    trait.options = await fieldTraitTextContentOptions(collection, collections);
    trait.title = `Get Value from Collection - ${collection.collectionTitle}`;
    trait.name = 'data-form-element-data-group';
  } else {
    trait.options = await fieldTraitTextContentOptions(collection, collections);
    trait.title = `Get Data from Collection - ${collection.collectionTitle}`;
    trait.name = 'data-text-content';
  }
  return trait;
};
export const getLinkDataListTraits = async (componentType, collection, collections) => {
  const trait = {
    type: 'data-group-href-field',
    label: false,
    changeProp: 1,
  };

  if (componentType === 'link') {
    trait.options = await fieldTraitTextContentOptions(collection, collections);
    trait.title = `Get URL from Collection - ${collection.collectionTitle}`;
    trait.name = 'data-href-content';
  } else {
    trait.options = await fieldTraitTextContentOptions(collection, collections);
    trait.title = `Get Data from Collection - ${collection.collectionTitle}`;
    trait.name = 'data-text-content';
  }
  return trait;
};

export const getProgressTotalListTraits = (componentType, collection, total) => {
  const trait = {
    type: 'data-progress-percentage',
    label: false,
    changeProp: 1,
    options: fieldTraitProgressBarOptions(collection),
  };
  if (componentType === 'progress-bar') {
    if (total) {
      trait.title = `Get Total from Collection - ${collection.collectionTitle}`;
      trait.name = 'data-progress-total';
    } else {
      trait.title = `Get Value from Collection - ${collection.collectionTitle}`;
      trait.name = 'data-progress-value';
    }
  }
  return trait;
};

export const fieldTraitTextContentOptions = async (collection, collections) => {
  return await getCollectionFieldTraitOptions(collection, collections);
};
const fieldTraitImageSrcOptions = async (collection, collections) => {
  let options = await getCollectionFieldTraitOptions(collection, collections);
  options = options.filter((field) => {
    const fieldMetaData = field.metaData ? JSON.parse(field.metaData) : '';
    return (
      (fieldMetaData && FileUrlFields.includes(fieldMetaData.fieldType)) ||
      FileUrlFields.includes(field.type)
    );
  });
  return options;
};

export const fieldTraitDateOptions = async (collection) => {
  if (!collection) {
    return [];
  }
  let options = [];
  const { fields } = collection;
  options = extractFieldOptions(fields, date.id);
  let textFields = extractFieldOptions(fields, text.id);
  options = [...options, ...textFields];
  return options;
};

export const textTraitDateOptions = async (collection) => {
  if (!collection) {
    return [];
  }
  let options = [];
  const { fields } = collection;
  options = extractFieldOptions(fields, text.id);
  return options;
};

const extractFieldOptions = (fields, fieldType) => {
  let fieldTypes = [];
  if (Array.isArray(fieldType)) {
    fieldTypes = [...fieldType];
  } else fieldTypes.push(fieldType);

  const fieldOptions = fields
    .filter((field) => {
      return fieldTypes.includes(field.type);
    })
    .map((item, key) => {
      return { id: item.fieldName, name: item.fieldTitle.en };
    });

  return fieldOptions;
};
export const fieldTraitOptions = (collection, fieldType) => {
  if (!collection) {
    return [];
  }
  let options = [];
  const { fields, utilities } = collection;
  const fieldOptions = extractFieldOptions(fields, fieldType);
  const utilityOptions = convertUtilityToOptions(utilities);
  options = [...fieldOptions, { id: '', name: '-------' }, ...utilityOptions];
  return options;
};
export const fieldTraitProgressBarOptions = (collection) => {
  return fieldTraitOptions(collection, textNumberField);
};

export const convertUtilityToOptions = (utilities) => {
  const utilityOptions = utilities.map((utility) => {
    const utilityJson = { args: utility.args, functionType: utility.functionType };
    return {
      id: JSON.stringify(utilityJson),
      name: utility.name,
    };
  });
  return utilityOptions;
};

export const filterFieldTraitOptions = async (collection, fieldTypes) => {
  if (!collection) {
    return [];
  }
  let options = [];
  const fieldOptions = [];
  const { fields, utilities } = collection;
  fieldTypes.forEach((element) => {
    const fieldTypeOptions = extractFieldOptions(fields, element);
    fieldOptions.push(...fieldTypeOptions);
  });
  const utilityOptions = convertUtilityToOptions(utilities);
  options = [...fieldOptions, { id: '', name: '-------' }, ...utilityOptions];
  return options;
};
